import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import { createPersonSuccess, fetchPeople, fetchPersonSuccess, PeopleAction } from './actions'
import { PeopleState } from './types'

export const peopleReducer = combineReducers<PeopleState, PeopleAction>({
  isFetching: (isFetching = false, action) => {
    switch (action.type) {
      case getType(fetchPeople.request):
        return true
      case getType(fetchPeople.success):
      case getType(fetchPeople.failure):
        return false
      default:
        return isFetching
    }
  },
  items: (people = {}, action) => {
    switch (action.type) {
      case getType(fetchPeople.request):
        return {}
      case getType(fetchPeople.success):
        return action.payload
      case getType(fetchPersonSuccess):
      case getType(createPersonSuccess): {
        const { person } = action.payload
        return {
          ...people,
          [person.id!]: person,
        }
      }
      default:
        return people
    }
  },
})
